// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.state-container {
  width: 12px;
}
.state-container .state-icon {
  height: 12px;
  width: 12px;
  border-radius: 50%;
}
.state-container .state-icon:before {
  color: white;
  left: 1px;
  bottom: 4px;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/state-control/state-control.component.scss"],"names":[],"mappings":"AACA;EACI,WAAA;AAAJ;AACI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AACR;AAEI;EACI,YAAA;EAEA,SAAA;EACA,WAAA;EACA,kBAAA;AADR","sourcesContent":["\n.state-container {\n    width: 12px;\n    .state-icon {\n        height: 12px;\n        width: 12px;\n        border-radius: 50%;\n    }\n\n    .state-icon:before {\n        color:white;\n       // content: var(--state-content);\n        left: 1px;\n        bottom: 4px;\n        position: relative;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
